export default __webpack_public_path__ + "static/lutein-vijdame-header-ad98166b4e90a2e666beaa720fc35f0b.webm";